import React from "react"
import Svg from "../../utils/Svg"
import Path from "../../utils/Path"
import G from "../../utils/SvgGroup"

const ZillowSvg = ({ color = "primary", ...rest }) => {
  return (
    <Svg
      fill="none"
      height="33"
      viewBox="-7 0 27 14"
      width="33"
      xmlns="http://www.w3.org/2000/svg"
    >
      <clipPath id="a">
        <Path d="m0 0h14v14h-14z" />
      </clipPath>
      <G clip-path="url(#a)">
        <Path
          fill={color}
          d="m9.24958 3.77519c.0643-.01423.09287.00711.13189.04981.22148.24522.92933 1.10623 1.12163 1.34105.0358.04269.011.08922-.0175.11385-1.42892 1.11006-3.01882 2.68264-3.90473 3.80694-.01759.02517-.0033.02517.01099.02134 1.54319-.66176 5.16874-1.71873 6.80144-2.01376v-2.05974l-6.39036-5.03468-6.401378 5.03085v2.25187c1.982298-1.17356 6.568998-2.99191 8.648018-3.50753z"
        />
        <Path
          fill={color}
          d="m4.0523 12.427c-.0533.0285-.09672.0214-.13959-.0213l-1.19311-1.4161c-.03187-.0394-.03572-.0607.00715-.1209.92217-1.3449 2.80445-3.44077 4.0047-4.32641.02144-.01423.01429-.03229-.01099-.02135-1.25027.4056-4.80433 1.92838-6.118898 2.66842v4.80974h12.792338v-4.63185c-1.7433.29503-6.96581 1.84295-9.3416 3.05975z"
        />
      </G>
    </Svg>
  )
}

export default ZillowSvg
